<script setup lang="ts">
import { computed } from 'vue';
import { TableInfo } from '../RevolverMatrix.ts';
import { useLocalization } from '@/composables';

const { lt } = useLocalization('uiRevolverMatrix');

const props = withDefaults(defineProps<{
  tables: TableInfo[];
  selectedIndex: number;
  backgroundColor: string;
  tabsWrapperClass?: string;
  tabsClass?: string;
  tabsSliderColor?: string;
  tableChipColor?: string;
}>(), {
  tabsWrapperClass: 'mb-2',
  tabsClass: 'rounded-lg',
  tabsSliderColor: '#000000',
  tableChipColor: '#000000',
});

const emit = defineEmits<{
  (e: 'select', index: number): void;
}>();

const selectedTab = computed({
  get: () => props.selectedIndex,
  set: (value: number) => emit('select', value)
});
</script>

<template>
  <div :class="tabsWrapperClass">
    <v-tabs
      v-model="selectedTab"
      :class="tabsClass"
      :bg-color="backgroundColor"
      :slider-color="tabsSliderColor"
      selected-class="v-tab--selected"
      grow
      show-arrows
      align-tabs="center"
      density="comfortable"
      height="52"
    >
      <v-tab
        v-for="(table, index) in tables"
        :key="table.id"
        :value="index"
        rounded="lg"
      >
        <div class="d-flex flex-column align-center py-1">
          <div class="d-flex align-center ga-2">
            <span
              class="text-body-1"
            >
              {{ table.name }}
            </span>
          </div>
          <!-- <v-chip
            size="x-small"
            variant="tonal"
            :color="tableChipColor"
          >
            {{ lt('table') }} {{ table.treeLevel }}
          </v-chip> -->
        </div>
      </v-tab>
    </v-tabs>
  </div>
</template>

<style scoped>
.v-tab--selected {
  background: rgba(255, 255, 255, 0.15);
}

.v-tab:hover:not(.v-tab--selected) {
  background: rgba(255, 255, 255, 0.08);
}
</style>
